import {Boards} from './Boards.js';
import {Template} from './Template.js';

export class BoardPost extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Template(`BoardPost`);
		this.inited=false;
	}
	init() {
		this.inited=true;
		this.appendChild(this.el);
		this.quill = new Quill(this.$.editor, {
			 theme: 'snow',
			 modules: {
			 	toolbar:  [
					  [{ 'header': [1, 2, 3, false] }],

			 		  ['bold', 'italic', 'underline'],        // toggled buttons
					  ['link'],

					  [{ 'list': 'ordered'}, { 'list': 'bullet' }],

					  // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

					  ['clean']                                         // remove formatting button
					]

			 }
		});
		this.$.post.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			this.closeClicked();
		});
		this.$.cancel.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			this.promise.resolve(null);
			this.el.close();
			this.el.parentNode.remove();
		});
		this.$.name.value = localStorage.getItem(`name`);
		this.$.email.value = localStorage.getItem(`email`);
	}
	closeClicked() {
		// Check the various values in our form
		const name = this.$.name.value;
		if (``!=name) localStorage.setItem(`name`, name);
		const email = this.$.email.value;
		if (``!=email) localStorage.setItem(`email`, email);
		const message = this.quill.getSemanticHTML();

		const board_id = this.getAttribute(`board-id`);
		const parent_id = this.getAttribute(`parent-id`);	// If this message is in reply to another
		Boards.API().BoardMessagePost(board_id, parent_id, name, email, message).then(
			res=>{
				this.promise.resolve(res);
		}).then( messages => {
			this.el.close();
			this.el.parentNode.remove();
		});
	}
	connectedCallback() {
		if (!this.inited) this.init();
		
	}
	setPromise(resolve,reject) {
		this.promise = {
			resolve: resolve,
			reject: reject,
		};
	}
	static post(boardId, parentId=0) {
		return new Promise( (resolve,reject)=>{
			const post = new BoardPost();
			post.setPromise(resolve,reject);
			post.setAttribute(`board-id`, boardId);
			post.setAttribute(`parent-id`, parentId);
			document.body.appendChild(post);
			post.el.showModal();
			console.log(`called post.showModal() on `, post);
		})
	}
}
customElements.define(`board-post`, BoardPost);
